import React from 'react'
import PropTypes from 'prop-types'
import { shuffle } from 'lodash'
import PageTitle from '../features/ui/util/page_title'
import DefaultLayout from '../layouts/default_layout'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import {
  LinkFooter,
  GabAdTopPanel,
  GabAdBottomPanel,
} from '../features/ui/util/async_components'
import RandomSidebarPanels from '../components/sidebar/random_sidebar_panels'

class ProPage extends React.PureComponent {

  render() {
    const { children } = this.props

    const title = 'Pro feed'

    const items = RandomSidebarPanels()
    const sidebarLayout = [
      <WrappedBundle key='pro-page-ad-panel' component={GabAdTopPanel} componentParams={{ pageKey: 'pro.sidebar', position: 1 }} />,
      ...shuffle(items),
      LinkFooter,
      <WrappedBundle key='pro-page-ad-panel-bottom' component={GabAdBottomPanel} componentParams={{ pageKey: 'pro.sidebar', position: 1 }} />
    ]

    return (
      <DefaultLayout
        showBackBtn
        title={title}
        page='pro'
        layout={sidebarLayout}
      >
        <PageTitle path={title} />
        {children}
      </DefaultLayout>
    )
  }

}

ProPage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ProPage
